module.exports = {
  0.7: '0.7rem',
};
